import React from 'react';
import SimpleProductPage from './SimpleProductPage';
import { screensData } from '../../data/screensData';

const GarminGpsmap1242xsv = () => {
  // Get the product data directly from screensData
  const productId = "gpsmap-1242xsv";
  const productData = screensData.find(item => item.id === productId);
  
  console.log('GarminGpsmap1242xsv - Direct Import - Product Data:', productData);
  console.log('GarminGpsmap1242xsv - Direct Import - Image URL:', productData?.image);
  
  // Use a direct image URL if we can't find one
  const imageUrl = productData?.image || "https://www.buildmyfishfinder.com/images/screens/garmin-gpsmap-1242xsv.jpg";
  
  // Force EXACT matching only - no fuzzy matching
  return (
    <SimpleProductPage 
      specificProductId="gpsmap-1242xsv"
      productName="Garmin GPSMAP 1242xsv"
      productImage={imageUrl}
      csvLookupId="GPSMAP 1242xsv"
      csvExactMatchOnly={true}
      componentType="screen"
    />
  );
};

export default GarminGpsmap1242xsv; 